import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CustomerManagementService } from '../services/customer-management/customer-management.service';
import { convertToUtcDate, convertTrialWindowToUtc } from 'src/util/date-helpers';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'customer-add-page',
    templateUrl: './customer-add-page.component.html',
    styleUrls: ['./customer-add-page.component.scss'],
    standalone: false
})
export class CustomerAddPageComponent {
  form: FormGroup;
  isConfiguringNotifications = false;

  constructor(private readonly fb: FormBuilder,
    private readonly customerService: CustomerManagementService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {
    this.form = fb.group({});
  }

  submitForm(){
    const { contractTerm: _, ...data} = this.form.getRawValue();
    data.createdDate = convertToUtcDate(data.createdDate);
    data.subscriptionStartDate = convertToUtcDate(data.subscriptionStartDate);
    data.subscriptionEndDate = convertToUtcDate(data.subscriptionEndDate);
    convertTrialWindowToUtc(data.subscriptionDetails);
    data.subdomain = "default";
    this.customerService.addCustomer(data).subscribe(res => {
      if(res?.ok){
        this.router.navigate(["../"], {relativeTo: this.route});
      }
    });
  }
  
    toggleNotificationsModal(){
      this.isConfiguringNotifications = !this.isConfiguringNotifications;
    }
  
    modalClosed(){
      this.isConfiguringNotifications = false;
    }
}
